const e = {
  login: {
    signUp: "Sign Up",
    quote: "“Welcome back! Resume your work seamlessly and enjoy a space built for creativity and connection. Never hesitate to get in touch if you need support.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    title: "Welcome back",
    subtitle: "Sign in to pick up where you left off.",
    emailLabel: "Email",
    emailPlaceholder: "Enter your work email...",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password...",
    login: "Sign in",
    forgotPassword: "Forgot password?"
  },
  signupVerification: {
    login: "Sign in",
    signupQuote: "“Welcome to a place where your ideas spark into reality. Our AI-assisted tools help you bring your visions to life quickly, all while keeping a human-first experience at the core of everything we do.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    verify: "Verify",
    title: "Verify your email",
    subtitle: "We've sent you an email with a verification code.",
    codeLabel: "Verification code",
    codePlaceholder: "Enter the code from the email...",
    codeResend: "Resend code"
  },
  forgotPassword: {
    login: "Sign in",
    quote: "“Every question is a stepping stone to progress — we are here to guide you every step of the way.”",
    quoteAuthor: "The graphapi Support Team",
    title: "Reset your password",
    subtitle: "We’ll send a verification code to the email address you enter below so you can confirm your identity.",
    emailLabel: "Email",
    emailPlaceholder: "Enter your work email...",
    continue: "Continue",
    errorEmailRequired: "Email is required"
  },
  authFooter: {
    imprintLink: "Imprint",
    termsOfServiceLink: "Terms of Service",
    privacyPolicyLink: "Privacy Policy"
  },
  signUp: {
    login: "Sign in",
    quote: "“Welcome back! Resume your work seamlessly and enjoy a space built for creativity and connection. Never hesitate to get in touch if you need support.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    title: "Create an account",
    subtitle: "Sign up to get started realizing your ideas.",
    signUp: "Sign up",
    emailLabel: "Email",
    emailPlaceholder: "Enter your work email...",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password...",
    choosePasswordPlaceholder: "Choose a password",
    errorEmailRequired: "Email is required",
    errorPasswordRequired: "Password is required",
    errorPasswordMinLength: "Password must be at least 8 characters"
  },
  changePassword: {
    login: "Sign in",
    quote: "“Welcome back! Resume your work seamlessly and enjoy a space built for creativity and connection. Never hesitate to get in touch if you need support.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    confirmPasswordLabel: "Repeat new password",
    confirmPasswordPlaceholder: "Confirm your password...",
    changePassword: "Change password",
    title: "Set new password",
    subtitle: "Enter the 6-digit verification code we've sent to your email address along with your new password. Once submitted, your password will be updated and you'll be able to sign in securely.",
    continue: "Continue",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password...",
    verifyCodeLabel: "Verification code",
    verifyCodePlaceholder: "Enter the code from the email...",
    resetPasswordTitle: "Reset your password",
    resetPasswordSubtitle: "Enter a new password for your account.",
    errorEmailRequired: "Email is required",
    errorPasswordRequired: "Password is required",
    errorPasswordMinLength: "Password must be at least 8 characters",
    errorVerificationCodeRequired: "Verification code is required",
    errorVerificationCodeInvalid: "Verification code is invalid",
    errorPasswordConfirmationRequired: "Password confirmation is required",
    errorPasswordMismatch: "Passwords do not match"
  },
  changeEmail: {
    settings: "Account Settings",
    quote: "“Welcome back! Resume your work seamlessly and enjoy a space built for creativity and connection. Never hesitate to get in touch if you need support.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    emailLabel: "New Email",
    emailPlaceholder: "Enter new work email...",
    title: "Set new email",
    subtitle: "Enter a new work email address and click continue. We’ll send a verification code to the email address you enter below so you can confirm your identity.",
    continue: "Continue",
    errorEmailRequired: "Email is required"
  },
  verifyEmail: {
    settings: "Account Settings",
    quote: "“Welcome back! Resume your work seamlessly and enjoy a space built for creativity and connection. Never hesitate to get in touch if you need support.“",
    quoteAuthor: "Jens Dressler - Founder & CEO",
    emailLabel: "New Email",
    emailPlaceholder: "Enter new work email...",
    title: "Verify your email",
    subtitle: "We sent a verification code to your new email address. Please enter the code below to confirm your identity.",
    continue: "Continue",
    verifyCodeLabel: "Verification code",
    verifyCodePlaceholder: "Enter the code from the email...",
    errorEmailRequired: "Email is required",
    errorVerificationCodeRequired: "Verification code is required",
    errorVerificationCodeInvalid: "Verification code is invalid",
    changeEmail: "Change email"
  }
};
export {
  e as defaultCopies
};
